(function () {
  var form = document.getElementById('hb-sort-form');
  if (form) {
    var select = form.querySelector('#hb-sort-by');
    if (select) {
      select.addEventListener('change', function () {
        form.submit();
      });
    }
  }

  var chipRail = document.getElementById('hb-chip-rail-form');
  if (chipRail) {
    chipRail.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"]')) {
        chipRail.submit();
      }
    });
  }
})();